export const isSchedulerView = () => {
    return (
        window.location.hash.startsWith('#/resource') ||
        window.location.hash.startsWith('#/project') ||
        window.location.hash.startsWith('#/scheduler')
    );
};
